// extracted by mini-css-extract-plugin
export var adjacentSlide = "_p6-9";
export var arrowButtonContainer = "_p6-5";
export var arrowButtonIcon = "_p6-6";
export var carouselArrowButton = "_p6-2";
export var carouselElementContainer = "_p6-1";
export var currentSlide = "_p6-8";
export var left = "_p6-3";
export var otherSlide = "_p6-a";
export var productCarouselContainer = "_p6-0";
export var right = "_p6-4";
export var sliderOverflow = "_p6-7";